export const withHook = <TProps, TViewProps>(
  hook: (parentProps: TProps) => TViewProps
) => {
  return (view: (props: TViewProps) => React.ReactElement | null) => (
    parentProps: TProps
  ) => view(hook(parentProps));
};
